import src from "IMAGE";
export default { src, width: 36, height: 36, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
